<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div fxFlex>
    <form [formGroup]="form"> 
      <mat-form-field class="width-100">
        <input 
          matInput
          #recipientInput
          formControlName="recipient" 
          [matAutocomplete]="recipientAC" 
          [placeholder]="'LABEL_RECIPIENT' | translate"
          (focus)="!recipientAC.isOpen && getInitialValues('recipient')" 
          [required]="isRequired"
          >

        <mat-icon 
          id="id_select_recipient_delete_btn"
          matSuffix 
          color="primary"
          class="clear-input"
          svgIcon="close-circle"
          (click)="recipientInput.blur(); clearForm($event)"
          *ngIf="recipientInput.value && !disabled"
          >
        </mat-icon>

        <mat-icon 
          matSuffix 
          class="clear-input"
          svgIcon="menu-down"
          *ngIf="!recipientInput.value"
          >
        </mat-icon>

        <mat-autocomplete 
          id="id_select_recipient_dropdown"
          [displayWith]="displayFn" 
          #recipientAC="matAutocomplete" 
          (closed)="autoCmpltClosed(); recipientInput.blur()"
          (opened)="autocompleteScroll('recipient','recipientACRef','recipientACTr')"
          >
          <mat-option
            disabled
            *ngIf="!loading.recipient && listData?.length == 0"
            >
            {{ 'LABEL_NO_DATA' | translate }}
          </mat-option>

          <mat-option
            [id]="'id_select_recipient_data_' + (i+1)"
            [value]="data" 
            matTooltipPosition="right"
            *ngFor="let data of listData; let i = index" 
            [matTooltip]="data.reference_code + ' - ' + data.fullname"
            >
            {{ data.reference_code }} - {{ data.fullname }}
          </mat-option>

          <mat-option *ngIf="loading.recipient" disabled>
            <mat-spinner color="primary" class="spinner-margin-auto" [diameter]="45"></mat-spinner>
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="form.get('recipient').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="form.get('recipient').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_recipient' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>